<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="组织架构" v-if="isShowSearch">
                <el-input v-model="searchForm.name" placeholder="请输入架构名称" @input="searchTextDidChange"
                    class="input-search" size="small"></el-input>
            </el-form-item>
        </el-form>
        <el-tree style="min-width: 150px;overflow-y: auto;padding-right: 20px;" :style="{height: treeHeight +'px',maxWidth: treeWidth+'px'}"
            :data="data" :props="defaultProps" @node-click="handleNodeClick" :filter-node-method="filterNode"
            node-key="id" highlight-current accordion :default-expand-all="defaultExpandAll"
            :expand-on-click-node="false" ref="treeRef" >
            <template slot-scope="{ node, data }">
                <span class="custom-tree-node">
                    <span style="margin-right: 10px;">{{ data.name || data.areaName }}</span>
                    <slot v-bind:data="data" name="extra"></slot>
                    
                </span>
            </template>
        </el-tree>
    </div>
</template>
<script>
export default {
    name: 'SalesRuleTeam',
    props: {
        data: {
            type: Array,
            default: () => []
        },
        treeHeight:{
            type: Number,
            default: 500
        },  
        treeWidth:{
            type: Number,
            default: 300
        },
        isShowSearch: {
            type: Boolean,
            default: true
        },
        // 是否默认展开所有节点
        // 默认否
        defaultExpandAll: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            defaultProps: {
                children: 'children',
                lable: 'name',
            },
            searchForm: {
                name: ''
            }
        }
    },
    methods: {
        publicSetCurrentNodeKey(key) {
            this.$refs.treeRef.setCurrentKey(key)
        },
        handleNodeClick(node) {
            this.$emit('nodeClick', node)
        },
        searchTextDidChange: _.throttle(function () {
            this.$refs.treeRef.filter(this.searchForm.name)
        }, 500),
        // 过滤输入框的节点
        filterNode(value, data) {
            if (!value) return true;
            if (data.areaName && data.areaName.includes(value)) {
                return data.areaName.includes(value);
            }
            if (data.name && data.name.includes(value)) {
                return data.name.includes(value);
            }
        },
    }
}

</script>
<style scoped lang="scss">
.custom-tree-node {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}
</style>